import { action } from 'satcheljs';

export type OcpsStoreUpdateType = 'POLICY' | 'RETRY';

export const ocpsLocalStorageUpdated: (event: OcpsStoreUpdateType) => {
    event: OcpsStoreUpdateType;
} = action('ocpsLocalStorageUpdated', (event: OcpsStoreUpdateType) => ({ event }));
